<template>
  <!--维权记录-出证订单-->
  <div class="order">
    <left-tab></left-tab>
    <div class="right-wrap">
      <el-table :data="listData"
                v-loading="loading"
                tooltip-effect="dark"
                class="data-list"
                :header-cell-style="{background: '#f9f9f9', color: '#333333', fontWeight: '500'}">
        <el-table-column label="订单号" prop="orderNumber" show-overflow-tooltip/>
        <el-table-column label="备案号" prop="pid">
          <template slot-scope="scope">{{scope.row.pid | leftPadZero(10)}}</template>
        </el-table-column>
        <el-table-column label="债务人" prop="debtorName" show-overflow-tooltip/>
        <el-table-column label="标的额" prop="creditorAmount" show-overflow-tooltip/>
        <el-table-column label="创建日期" prop="createTime">
          <template slot-scope="scope">{{scope.row.createTime | formatDate}}</template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" prop="dealStatusStr" show-overflow-tooltip/>
        <no-data text="暂无数据" slot="empty"/>
      </el-table>
      <el-row class="pageation row" v-if="listData && listData.length > 0">
        <el-col :span="6">
          <div style="height: 20px;"><!--占位--></div>
        </el-col>
        <el-col :span="18" class="page-flex-end">
          <el-pagination v-if="paged.total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pager-count="5"
            :current-page.sync="paged.pageNum"
            :page-size="paged.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="sizes, prev, pager, next, total"/>
          <el-go :page-size="paged.pageSize" :total="paged.total" @current-change="handleCurrentChange"></el-go>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {ApiMethods} from '@/assets/js/http-serve/http-methods';
  import ElGo from '../../components/go/Go';
  import LeftTab from '../../components/judicialService/leftTab'

  export default {
    components: {ElGo,LeftTab},
    methods: {
      queryList: function () {
        let param = {pageSize: this.paged.pageSize, itemPage: this.paged.pageNum};
        this.loading = true;
        ApiMethods.SafeguardController.sjwInfo(param).then(result => {
          if (!result.success && this.$store.getters.authUser.identityAuth > -1) {
            return this.$message.error(result.description || "查询数据失败")
          }
          this.paged = {pageNum: result.pageNum, pageSize: result.pageSize, pages: result.pages, total: result.total};
          this.listData = result.data;
        }).finally(() => {
          this.loading = false;
        });
      },
      handleCurrentChange: function (val) {
        this.paged.pageNum = val;
        this.queryList();
      },
      handleSizeChange: function (val) {
        this.paged.pageSize = val;
        this.queryList();
      },
    },
    created() {
      this.queryList();
    },
    data() {
      return {
        paged: {pageNum: 1, pageSize: 10},
        listData: [],
        loading: false
      }
    },
    name: "sjw"
  }
</script>

<style lang="less" scoped>
  .table-box {
    padding-top: 20px;
  }

  .order {
    height: 100%;
    max-width: 1200px;
    position: relative;
    display: block;
    margin: 0 auto;
    /*margin: 10px auto 0 auto;*/
    .safeguard-bar {
      width: 100%;
      margin-top: 20px;
      border: 1px dashed #D7D7D7;
      overflow: hidden;
      ul {
        li {
          display: inline-block;
          margin-right: 14px;
          padding: 10px;
          color: #666;
          border: none;
          background: #fff;
          cursor: pointer;
        }
        li.active {
          color: #ec1c1c;
        }
      }
    }
    .pageation {
      padding: 30px 10px 20px 10px;
      border-top: 0;
    }
    .dialog-footer {
      padding-bottom: 20px;
      .btn {
        width: 30%;
      }
    }
  }
  .right-wrap {
    position: relative;
    height: 100%;
    margin-left: 215px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 15px;

    .table-wrap {
      padding: 0 16px;
    }

    /deep/ .row {
      padding: 15px;
      height: 62px;
      min-height: 62px;
    }

    /deep/ .data-list {
      height: calc(100vh - 406px);
      width: inherit;
      margin: 0 15px;
      border: 1px solid #EEEEEE;
    }

    /deep/ .el-table__body-wrapper {
      height: calc(100% - 48px);
      overflow-y: auto;
    }

    /deep/ .go-style {
      top: 17px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/judicialService/sjw.vue